import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Location } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { SkuListItem } from "src/app/models/priceyard.model";
import { GridApiService } from "src/app/data-grid/grid-api.service";
import { takeUntil } from "rxjs/operators";
import { LoginModel } from "src/app/models/login.model";
import { Subject } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { ConfirmDialogComponent } from "src/app/components/dialogs/confirm-dialog/confirm-dialog.component";
import { GridActionsService } from "../../data-grid/grid-actions.service";
@Component({
  selector: "app-multi-edit",
  templateUrl: "./multi-edit.component.html",
  styleUrls: ["./multi-edit.component.scss"],
})
export class MultiEditComponent implements OnInit, OnDestroy {
  skus: SkuListItem[];
  userInfo: LoginModel;
  private destroy$ = new Subject<void>();
  shipmentType = new FormControl();
  isPriceyard:boolean=false;
  isPricing: boolean;
  fbaTypes = this.shipyardService.getAllShipmentTypes();
  
  constructor(
    private gridApiService: GridApiService,
    public gridActionsService: GridActionsService,
    public shipyardService: ShipyardService,
    private authService: AuthService,
    private location: Location,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {    
    this.isPriceyard= this.location.path().includes("priceyard");
    this.gridApiService.selectedRows$
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedRows) => {
       this.isPricing = selectedRows[0].hasOwnProperty("IsRepricing")
        this.skus = selectedRows;
        const len = this.skus.length;
        if (len > 1) {
          this.shipmentType.setValue(
            this.shipyardService.getShipmentTypeId(selectedRows[len - 1].FbaType)
          );
        }
      });

    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => (this.userInfo = res));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  updateFbaType() {    
    this.dialog
    .open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Update FBA Type",
        message: "Are you sure you want to update FBA Type?",
      },
    })
    .afterClosed()
    .subscribe((res) => {      
      if (res === "Confirm"){
        this.gridActionsService.updateFbaType(this.skus, this.shipmentType) 
      }else{
        this.shipmentType.setValue(
          this.shipyardService.getShipmentTypeId(this.skus[this.skus.length-1].FbaType));
      }
    });
  }
}
